module.exports = __webpack_public_path__ + "img/aca_30.64742caf.png";